import { css } from '@emotion/react'

const product = css`
  width: 40%;
  padding-left: 5px;
`

const stock = css`
  width: 25%;
  text-align: right;
`

export const styles = { product, stock }
